export default function Comparison() {
  const rows = [
    { feature: 'Przetwarzanie dużych zbiorów', usfans: true, excel: true, sheets: false },
    { feature: 'Współpraca w czasie rzeczywistym', usfans: true, excel: false, sheets: true },
    { feature: 'Wbudowana automatyzacja', usfans: true, excel: false, sheets: false },
    { feature: 'Szablony niestandardowe', usfans: true, excel: true, sheets: true },
    { feature: 'Bezpieczeństwo klasy enterprise', usfans: true, excel: true, sheets: true },
    { feature: 'Dostępność offline', usfans: true, excel: true, sheets: false },
    { feature: 'Integracje API', usfans: true, excel: false, sheets: true },
    { feature: 'Wsparcie eksportu wielu formatów', usfans: true, excel: true, sheets: true },
    { feature: 'Natywna aplikacja mobilna', usfans: true, excel: true, sheets: true },
    { feature: 'Cena przystępna dla zespołów', usfans: true, excel: false, sheets: true },
  ];

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            Porównanie
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            USFansSpreadsheet vs Excel vs Google Sheets
          </h2>
          <p className="text-foreground-600 max-w-[650px] mx-auto leading-relaxed">
            Porównanie kluczowych funkcji trzech popularnych narzędzi do zarządzania arkuszami kalkulacyjnymi. 
            Sprawdź, które rozwiązanie najlepiej odpowiada Twoim potrzebom.
          </p>
        </div>

        <div className="overflow-x-auto rounded-xl border border-background-200/70">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-background-100">
                <th className="text-left px-5 py-4 font-semibold text-foreground-950 whitespace-nowrap">Funkcja</th>
                <th className="text-center px-5 py-4 font-semibold text-primary-600 whitespace-nowrap">
                  <span className="inline-flex items-center gap-1.5">
                    <i className="ri-star-fill text-xs"></i>
                    USFansSpreadsheet
                  </span>
                </th>
                <th className="text-center px-5 py-4 font-semibold text-foreground-600 whitespace-nowrap">Excel</th>
                <th className="text-center px-5 py-4 font-semibold text-foreground-600 whitespace-nowrap">Google Sheets</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr key={row.feature} className={`border-t border-background-200/70 ${i % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'}`}>
                  <td className="px-5 py-3.5 text-foreground-700">{row.feature}</td>
                  <td className="px-5 py-3.5 text-center">
                    {row.usfans ? (
                      <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-primary-100 text-primary-600">
                        <i className="ri-check-line text-xs"></i>
                      </span>
                    ) : (
                      <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-foreground-100 text-foreground-400">
                        <i className="ri-close-line text-xs"></i>
                      </span>
                    )}
                  </td>
                  <td className="px-5 py-3.5 text-center">
                    {row.excel ? (
                      <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-secondary-100 text-secondary-600">
                        <i className="ri-check-line text-xs"></i>
                      </span>
                    ) : (
                      <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-foreground-100 text-foreground-400">
                        <i className="ri-close-line text-xs"></i>
                      </span>
                    )}
                  </td>
                  <td className="px-5 py-3.5 text-center">
                    {row.sheets ? (
                      <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-secondary-100 text-secondary-600">
                        <i className="ri-check-line text-xs"></i>
                      </span>
                    ) : (
                      <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-foreground-100 text-foreground-400">
                        <i className="ri-close-line text-xs"></i>
                      </span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}